<template>
	<div class="row">
		<div class="col-md-12">
			<div class="form-group">
				<label>Resource Type</label>
				<multiselect
					name="link_type"
					:options="optionsForLinkType.map(x => x.id)"
					label="name"
					v-model="linkType.value"
					:allow-empty="false"
				>
					<template slot="singleLabel" slot-scope="props">
						<img class="link-type-icon" :src="require(`@/csmworkflow/img/${getOptionObject(props.option).icon}`)" alt="icon">
						<span class="link-type-title">{{ getOptionObject(props.option).name }}</span>
					</template>
					<template slot="option" slot-scope="props">
						<img class="link-type-icon" :src="require(`@/csmworkflow/img/${getOptionObject(props.option).icon}`)" alt="icon">
						<span class="link-type-title">{{ getOptionObject(props.option).name }}</span>
					</template>
				</multiselect>
			</div>
		</div>
		<div class="col-md-12">
			<div class="form-group">
				<label>URL <i class="far fa-copy"></i></label>
				<div class="input-group">
					<input required type="text" v-model="linkUrl.value" class="form-control"  v-on:keyup.enter="saveFn" ref="focusThis"/>
					<div class="input-group-append">
						<button @click="copyUrl" id="copy-url-btn" class="btn btn-text btn-copy" type="button" data-dismiss="modal"><i :class="copyIcon"></i></button>
						<b-tooltip target="copy-url-btn" triggers="hover" noninteractive>{{copyTooltipText}}</b-tooltip>
					</div>
				</div>
			</div>
		</div>
		<div class="col-md-12" v-show="error">
			<div class="alert alert-danger">URL is invalid</div>
		</div>
		<div class="col-md-12">
			<div class="form-group">
				<label>Label</label>
				<input type="text" v-model="linkLabel.value" class="form-control"  v-on:keyup.enter="saveFn"/>
			</div>
		</div>
		<div class="col-md-12">
			<div class="form-group">
				<label>Notes</label>
				<textarea class="form-control" v-model="linkNotes.value"></textarea>
			</div>
		</div>

		<div class="row col-md-12">
		<div class="col">
			<button class="btn btn-primary" type="button" @click="saveFn" data-dismiss="modal">Save</button>
		</div>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import Autolinker from 'autolinker';

export default {
	props: {
		linkUrl:Object,
		linkLabel:Object,
		linkNotes:Object,
		linkType:Object,
		namespace:String,
	},
	data() {
		return {
			fieldId: 37,
			filteredStates: [],
			error: false,
			copySuccessTimeout: null,
			copyIcon: 'far fa-copy',
			copyTooltipText: 'Copy URL',
		};
	},
	computed: {
		...mapState({
		  state (state) {
		    return state[this.namespace]
		  },
		  socialSeriesDetail (state, getters) {
		    return getters[this.namespace + 'socialSeriesDetail']
		  },
		  allCustomFields (state, getters) {
		    return getters[this.namespace + 'allCustomFields']
		  },
		}),
		optionsForLinkType() {
			const linkTypeField = this.allCustomFields.find(x => x.id == this.fieldId);
			return JSON.parse(linkTypeField.value_set);
		},
	},
	methods: {
		focusMyElement() {
			if (this.$refs.focusThis) {
				this.$refs.focusThis.focus();
			}
		},
		saveFn() {
			let that = this;
			that.error = false;
			if(!that.linkUrl.value) {
				that.error = true;
				return;
			}
			let url = that.linkUrl.value.trim();
			let matches = Autolinker.parse(url, {
				urls: true
			});
			if (matches.length > 0) {
				if (matches[0].type == "url") {
					url = matches[0].getUrl();
				} else {
					that.error = true;
				}
			} else {
				that.error = true;
			}
			if (!that.error) {
				this.$store.dispatch(this.namespace + "addSocialSeriesResourceUrl", {
					socialCampaignFieldId: this.fieldId,
					linkUrl: this.linkUrl,
					linkLabel: this.linkLabel,
					linkNotes: this.linkNotes,
					linkType: this.linkType
				}).then(() => {
					that.$bvModal.hide('createSocialSeriesLinkModal')
				});
			}
		},
			removeFn() {
				this.$bvModal.hide('createSocialSeriesLinkModal')
			},
		getOptionObject(id) {
			return this.optionsForLinkType.find(x => x.id == id);
		},

		async copyUrl() {
			clearTimeout(this.copySuccessTimeout);
			const navPer = await navigator.permissions.query({name: "clipboard-write"});
			if (navPer.state == "granted" || navPer.state == "prompt") {
				try {
					await navigator.clipboard.writeText(this.linkUrl.value);
				} catch {
					console.error("clipboard API error. Cannot copy to clipboard.");
					this.legacyCopyMethod();
				}
			} else {
				this.legacyCopyMethod();
			}


			this.copyIcon = "fas fa-check";
			this.copyTooltipText = "Copied!";
			this.copySuccessTimeout = setTimeout(() => {
				this.copyIcon = "far fa-copy";
				this.copyTooltipText = "Copy URL";
			}, 2000);
		},
		legacyCopyMethod() {
			this.$refs.focusThis.select();
			document.execCommand("copy");
			this.$refs.focusThis.blur();
		},
	},
	created() {
		
	}
};
</script>

<style>
</style>